import type { ReactNode } from "react";

import "./Alerta.css";

type Tom = "erro" | "atencao" | "informacao" | "sucesso";

const ICONE: Record<Tom, string> = {
  erro: "✕",
  atencao: "!",
  informacao: "i",
  sucesso: "✓",
};

interface Props {
  tom: Tom;
  children: ReactNode;
  /** Título curto. Opcional — a mensagem sozinha costuma bastar. */
  titulo?: string;
}

/**
 * Mensagem de estado.
 *
 * <p>Sempre com **ícone e texto**, nunca só cor. Além da acessibilidade,
 * é o que faz a mensagem sobreviver a monitor ruim e impressão em preto e
 * branco — os dois comuns em laboratório.
 *
 * <p>`role="alert"` no tom de erro para que o leitor de tela anuncie sem
 * a pessoa ter de procurar.
 */
export function Alerta({ tom, titulo, children }: Props) {
  return (
    <div
      className={`ui-alerta ui-alerta--${tom}`}
      role={tom === "erro" ? "alert" : "status"}
    >
      <span className="ui-alerta__icone" aria-hidden="true">
        {ICONE[tom]}
      </span>
      {/* Tem classe porque o CSS precisa alcançá-lo: é este item de flex que
          se recusa a encolher abaixo da mensagem e joga o texto do servidor
          para fora da tela. Seletor por posição (`.ui-alerta > div`) sairia do
          lugar no primeiro elemento que alguém acrescentasse aqui. */}
      <div className="ui-alerta__corpo">
        {titulo !== undefined && <strong className="ui-alerta__titulo">{titulo}</strong>}
        <div>{children}</div>
      </div>
    </div>
  );
}
